import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { WowBadge } from "../badge/wow-badge";
import { iconBadgeStyles } from "./icon-badge.css";

@customElement("icon-badge")
export class IconBadge extends WowBadge {
  static override styles = [...WowBadge.styles, iconBadgeStyles];

  override render() {
    if (this.primaryColor) {
      this.style.setProperty("--badge-bg", this.primaryColor);
    }
    if (this.secondaryColor) {
      this.style.setProperty("--badge-color", this.secondaryColor);
    }

    return html`
      <div class="badge ${this.size} ${this.glass ? "glass" : ""}">
        <slot name="icon"></slot>
        <span class="badge-text"><slot></slot></span>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "icon-badge": IconBadge;
  }
}
